export enum TrackingEvent {
  ReportListDeleted = `Report list - deleted`,
  ReportListOpen = `Report list - open`,
  ReportListSelected = `Report list - selected`,
  ReportSaved = `Report saved`,
  ReportSavedAsNew = `Report saved as new`,
  ResetState = `Reset state`,
  LaunchTour = `Launch tour`,
}
